module.exports = __webpack_public_path__ + "static/img/shop-open.c17db9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report/shop-open.png
// module id = ruQK
// module chunks = 2